import React, { createContext, useContext, useEffect, useState } from "react";

async function loadCitiesAndPolygons() {
  const LISTS_VERSIONS_URL = "https://api.tzevaadom.co.il/lists-versions";
  async function fetchListsVersion() {
    const data = await fetch(LISTS_VERSIONS_URL)
      .then(async (r) => r.json())
      .catch((z) => null);
    return data;
  }
  const listsVersions = await fetchListsVersion();
  const polygonsVersion = listsVersions?.polygons || 4;
  const citiesVersion = listsVersions?.cities || 9;
  let citiesList;
  let polygonsList;
  const fetchCities = async () => {
    citiesList = JSON.parse(localStorage.getItem("citiesJSON") || "{}");
    if (
      (localStorage.getItem("citiesVersion") || -1) == citiesVersion &&
      Object.keys(citiesList).length > 0
    ) {
      console.log("cities was loaded successfully from localStorge.");
    } else {
      citiesList = await fetch("/static/cities.json?v=" + citiesVersion)
        .then(async (r) => await r.json())
        .catch(() => {
          return {};
        });
      if (Object.keys(citiesList).length > 0) {
        localStorage.setItem("citiesJSON", JSON.stringify(citiesList));
        localStorage.setItem("citiesVersion", citiesVersion);
        console.log("cities was loaded successfully from server.");
      }
    }
  };
  const fetchPolygons = async () => {
    polygonsList = JSON.parse(localStorage.getItem("polygonsJSON") || "{}");
    if (
      (localStorage.getItem("polygonsVersion") || -1) == polygonsVersion &&
      Object.keys(polygonsList).length > 0
    ) {
      console.log("polygons was loaded successfully from localStorge.");
    } else {
      polygonsList = await fetch("/static/polygons.json?v=" + polygonsVersion)
        .then(async (r) => await r.json())
        .catch(() => {
          return {};
        });
      if (Object.keys(polygonsList).length > 0) {
        localStorage.setItem("polygonsJSON", JSON.stringify(polygonsList));
        localStorage.setItem("polygonsVersion", polygonsVersion);
        console.log("polygons was loaded successfully from server.");
      }
    }
  };
  await Promise.all([fetchCities(), fetchPolygons()]);
  return [citiesList, polygonsList];
}

const CreateState = () => {
  const [cities, setCities] = useState({});
  const [polygons, setPolygons] = useState({});

  useEffect(() => {
    loadCitiesAndPolygons().then(([c, p]) => {
      setCities(c);
      setPolygons(p);
    });
  }, []);

  return { cities, polygons };
};
const ListsContext = React.createContext({});

const ListsProvider = ({ children }) => {
  return (
    <ListsContext.Provider value={CreateState()}>
      {children}
    </ListsContext.Provider>
  );
};

const useLists = () => {
  return useContext(ListsContext);
};

export { ListsProvider, useLists };
